// extracted by mini-css-extract-plugin
module.exports = {"accountDetailsPage":"styles_accountDetailsPage__1EJkR","emptyPage":"styles_emptyPage__6Y5BA","header":"styles_header__1yEaH","body":"styles_body__yuSgg"};